const packageInitState = {
    packageDetailsData: {}
};

export default packageInitState;
